module.exports = __webpack_public_path__ + "img/loading-on-base.9a975c0c.png";